import React from 'react';
import {
  WebBackHandlerContext,
  type WebBackHandlerContextType,
} from './WebBackHandlerProvider';

export interface WithWebBackHandlerProps {
  webBackHandler?: WebBackHandlerContextType;
}

export function withWebBackHandler<P extends WithWebBackHandlerProps>(
  WrappedComponent: React.ComponentType<P>
) {
  return function WithWebBackHandlerWrapper(props: Omit<P, keyof WithWebBackHandlerProps>) {
    return (
      <WebBackHandlerContext.Consumer>
        {(context) => {
          // if (!context) {
          //   throw new Error('WebBackHandlerContext not found. Wrap with WebBackHandlerProvider.');
          // }
          return <WrappedComponent {...(props as P)} webBackHandler={context ?? undefined} />;
        }}
      </WebBackHandlerContext.Consumer>
    );
  };
}
